function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.25,
  d: "M10 3.23a6.77 6.77 0 100 13.54 6.77 6.77 0 000-13.54zM2 10a8 8 0 1116 0 8 8 0 01-16 0z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11.32l4.13-4.13c.13-.13.3-.19.49-.19.2 0 .36.06.49.2.13.12.2.28.2.48 0 .2-.07.36-.2.5l-4.62 4.61a.67.67 0 01-.98 0L6.2 10.97a.66.66 0 01-.19-.49c0-.2.06-.36.2-.49.12-.13.28-.2.48-.2.2 0 .36.07.5.2l1.32 1.33z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.5 11.04l3.99-3.99a.86.86 0 01.63-.25.86.86 0 01.88.88c0 .25-.08.46-.25.63l-4.62 4.62a.87.87 0 01-1.26 0l-1.82-1.82a.86.86 0 01-.25-.63.86.86 0 01.88-.88c.25 0 .46.08.63.25l1.2 1.19zm4.13-3.85c.13-.13.3-.19.49-.19.2 0 .36.06.49.2.13.12.2.28.2.48 0 .2-.07.36-.2.5l-4.62 4.61a.67.67 0 01-.98 0L6.2 10.97a.66.66 0 01-.19-.49c0-.2.06-.36.2-.49.12-.13.28-.2.48-.2.2 0 .36.07.5.2l1.32 1.33 4.13-4.13z",
  clipRule: "evenodd"
});

function SvgTickOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOutlined);
export default __webpack_public_path__ + "static/media/tick-outlined.f8c0401b.svg";
export { ForwardRef as ReactComponent };